import { TRENDING_STATUS } from '../constants';

const getArrowIcon = (status, upIsPositive = true) => {
  if (status === TRENDING_STATUS.NEUTRAL) return null;

  const positiveIcon = upIsPositive ? 'icon-flechaarriba' : 'icon-flechaabajo';
  const negativeIcon = upIsPositive ? 'icon-flechaabajo' : 'icon-flechaarriba';

  const mapIcons = {
    [TRENDING_STATUS.NEUTRAL]: null,
    [TRENDING_STATUS.POSITIVE]: positiveIcon,
    [TRENDING_STATUS.NEGATIVE]: negativeIcon,
  };

  return mapIcons[status];
};

export default getArrowIcon;
